import * as formatters from "../formatters";

export default [
  { name: "end_ride", title: "ended ride" },
  { name: "assign_captain", title: "updated captain", hasExtra: true },
  { name: "set_captain_price", title: "updated captain price", hasExtra: true },
  { name: "arrive_station", title: "arrived station", hasExtra: true },
  { name: "depart_station", title: "departed station", hasExtra: true },
  { name: "enable_bookings", title: "enabled bookings" },
  { name: "disable_bookings", title: "disabled ride bookings" },
  { name: "mark_emergency", title: "marked ride as emergency" },
  { name: "unmark_emergency", title: "unmarked ride as emergency" },
  { name: "end", title: "ended ride" },
  { name: "cancel", title: "cancelled ride" },
  { name: "update_captain", title: "updated captain" },
  {
    name: "update_date",
    title: "updated ride date",
    formatter: formatters.date,
  },
  {
    name: "update_captain_price",
    title: "updated captain price",
    formatter: formatters.price,
  },
];



// WEBPACK FOOTER //
// ./src/services/auditorHandler/lists/ride.js